import { closeToast, openToast } from "./toastReducer";

class ToastNotificationDispatcher {
  private dispatch;

  constructor(dispatch: any) {
    this.dispatch = dispatch;
  }

  openToast(data: any): void {
    this.dispatch(openToast(data));
  }

  closeToast(): void {
    this.dispatch(closeToast());
  }
}

export default ToastNotificationDispatcher;
